
import { RouteObject } from 'react-router-dom';
import SplashScreen from '../pages/splash/page';
import AuthPage from '../pages/auth/page';
import Home from '../pages/home/page';
import OrdersPage from '../pages/orders/page';
import ProfilePage from '../pages/profile/page';
import BookingPage from '../pages/booking/page';
import BiddingPage from '../pages/booking/bidding/page';
import ConfirmBookingPage from '../pages/booking/confirm/page';
import TripTrackingPage from '../pages/trip/tracking/page';
import PaymentPage from '../pages/trip/payment/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <SplashScreen />
  },
  {
    path: '/auth',
    element: <AuthPage />
  },
  {
    path: '/home',
    element: <Home />
  },
  {
    path: '/orders',
    element: <OrdersPage />
  },
  {
    path: '/profile',
    element: <ProfilePage />
  },
  {
    path: '/booking',
    element: <BookingPage />
  },
  {
    path: '/booking/bidding',
    element: <BiddingPage />
  },
  {
    path: '/booking/confirm',
    element: <ConfirmBookingPage />
  },
  {
    path: '/trip/tracking',
    element: <TripTrackingPage />
  },
  {
    path: '/trip/payment',
    element: <PaymentPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
